@if ((fetchingResults$ | async)!) {
  <p style="text-align:center">
    <mat-spinner style="margin:0 auto;"  [diameter]="40"></mat-spinner>
  </p>
}

@if (!(fetchingResults$ | async)!) {
  <div class="customer-keep">
    <div>
      @switch (transactionStages[0]) {
        @case (TransactionStage.DRAFT) {
          <h1>Mes entretiens planifiés ({{ (myKeepCars$  | async)?.length}})</h1>
        }
        @case (TransactionStage.CONFIRMED) {
          <h1>Mes réservations pour entretien ({{ (myKeepCars$  | async)?.length}})</h1>
        }
        @case (TransactionStage.ONGOING) {
          <h1>Mes entretiens en cours ({{ (myKeepCars$  | async)?.length}})</h1>
        }
        @case (TransactionStage.COMPLETED) {
          <h1>Mes entretiens complétés ({{ (myKeepCars$  | async)?.length}})</h1>
        }
      }
    </div>
    @if (((myKeepCars$  | async) == undefined || (myKeepCars$  | async)!.length ==0)) {
      <h6>
        Aucun entretien en cours
        <br />
        <br />
        <a [routerLink]="'/keep/search'"> <mat-icon>search</mat-icon> Rechercher </a>
      </h6>
    }
    @if (((myKeepCars$  | async) != undefined )) {
      <div class="cars-section">
        @for (car of (myKeepCars$  | async)!; track car; let i = $index) {
          <div id="{{car.carId}}" class="car-section">
            <app-car-card-buyer
              [car]="car"
              [carImagesFolder]="(carImagesFolders$ | async)!.get(car.carId)!"
              [businessLine]="businessLine"
              [objectSource]="objectSource">
            </app-car-card-buyer>
          </div>
        }
      </div>
    }
    <!--
    <div class="car-list" *ngIf="((myKeepCars$  | async) !== undefined )">
      <div *ngFor="let car of myKeepCars; index as i" id="{{car.carId}}" class="car-section">
        <app-car-card-account
          [car]="car"
          [businessLine]="businessLine"
          [carImagesFolder]="(carImagesFolders$ | async)!.get(car.carId)!">
        </app-car-card-account>
        <mat-accordion multi>
          <mat-expansion-panel [expanded]="car.bookings.length < 2">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <h4> Réservations en cours <span *ngIf="car.bookings != undefined">({{car.bookings.length}}) </span></h4>
                <button *ngIf="canNewBooking(car.bookings)"
                  class="cta-button-keep"  mat-button (click)="openBookingDialog(car.carId, 0);$event.stopPropagation()">
                  <mat-icon>add</mat-icon> Nouvelle
                </button>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <app-bookings
              [objectSource]="objectSource"
              [carId]="car.carId"
              [enableNew]="false">
            </app-bookings>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div> -->
  </div>
}
